import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SupplierDeleteSupplierWarehouse,
  SupplierFilterSupplierWarehouse,
  SupplierFilterWarehouseType,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function SupplierWarehouse() {
  const [Search, setSearch] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [warehouseType, setWarehouseType] = useState([]);

  const navigate = useNavigate();
  let { id } = useParams();

  const start = async () => {
    try {
      const SupplierFilterSupplierWarehouseData =
        await SupplierFilterSupplierWarehouse({
          supplierId: id,
        });
      if (
        SupplierFilterSupplierWarehouseData.status &&
        SupplierFilterSupplierWarehouseData.status === 200
      ) {
        setData(SupplierFilterSupplierWarehouseData.data.data.data);
      }
      const SupplierFilterWarehouseTypeData =
        await SupplierFilterWarehouseType({});
      if (
        SupplierFilterWarehouseTypeData.status &&
        SupplierFilterWarehouseTypeData.status === 200
      ) {
        setWarehouseType(
          SupplierFilterWarehouseTypeData.data.data.data
        );
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const SupplierFilterSupplierWarehouseData =
        await SupplierFilterSupplierWarehouse({
          supplierId: id,
        });
      if (
        SupplierFilterSupplierWarehouseData.status &&
        SupplierFilterSupplierWarehouseData.status === 200
      ) {
        setData(SupplierFilterSupplierWarehouseData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      let searching = { ...Search };
      const SupplierFilterSupplierWarehouseData =
        await SupplierFilterSupplierWarehouse({
          ...searching,
          supplierId: id,
        });
      if (
        SupplierFilterSupplierWarehouseData.status &&
        SupplierFilterSupplierWarehouseData.status === 200
      ) {
        setData(SupplierFilterSupplierWarehouseData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف مرکز",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const SupplierDeleteSupplierWarehouseData =
        await SupplierDeleteSupplierWarehouse(e);
      if (
        SupplierDeleteSupplierWarehouseData.status &&
        SupplierDeleteSupplierWarehouseData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate(`/Panel/Suppliers/Warehouse/Add/${id}`);
  };

  const Edite = (extraParam) => {
    navigate(`/Panel/Suppliers/Warehouse/Edite/${id}/${extraParam}`);
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
            <div className="w-100 d-flex justify-content-end">
              <button
                onClick={() => {
                  navigate("/Panel/Suppliers/Warehouse/Type");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                نوع
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
              className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="city"
              id="city"
              text="شهر"
              className="m-2"
              value={Search.city || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="address"
              id="address"
              text="ادرس"
              className="m-2"
              value={Search.address || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="phone"
              id="phone"
              text="شماره"
              className="m-2"
              value={Search.phone || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="fullName"
              id="fullName"
              text="نام کامل"
              className="m-2"
              value={Search.fullName || ""}
              onChange={handleChangeSearch}
            />
            <Select
              className="m-2"
              type="number"
              name="warehouseTypeId"
              id="warehouseTypeId"
              text="نوع"
              value={Search.warehouseTypeId || ""}
              onChange={handleChangeSearch}
              option={warehouseType.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>Supplier</th>
                  <th>نوع</th>
                  <th>نام</th>
                  <th>شهر</th>
                  <th>ادرس</th>
                  <th>شماره</th>
                  <th>نام کامل</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.supplierName}</td>
                    <td>{item.warehouseTypeName}</td>
                    <td>{item.name}</td>
                    <td>{item.city}</td>
                    <td>{item.address}</td>
                    <td>{item.phone}</td>
                    <td>{item.fullName}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierWarehouse;
